import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ChevronUp, Check } from 'lucide-react';
import Hero from '../images/studiopic.jpg'
const Home = () => {
   const videoRef = useRef(null);
    const [currentDate, setCurrentDate] = useState("");
    const [expandedCard, setExpandedCard] = useState(null);
  
    useEffect(() => {
      const today = new Date();
      const options = { day: "2-digit", month: "short", year: "numeric" };
      const formattedDate = today
        .toLocaleDateString("en-US", options)
        .replace(",", "");
      setCurrentDate(formattedDate);
    }, []);
  
    useEffect(() => {
      if (videoRef.current) {
        videoRef.current.playbackRate = 0.9;
      }
    }, []);
  
    const toggleCard = (cardIndex) => {
      setExpandedCard(expandedCard === cardIndex ? null : cardIndex);
    };
  
    const donationCards = [
      {
        title: "One Class Pass",
        price: 15,
        subtitle: "One Time Session",
        validity: "Valid For One Day",
        features: [
          "10:00 AM – 11:00 AM Calm and Chai Sunday",
          "6:00 PM – 7:00 PM Hatha Yoga (Tuesday & Thursday)",
          "Hatha Yoga with gentle postures",
          "Breathwork to soothe the nervous system",
          "Meditation and mindfulness practice"
        ]
      },
      // {
      //   title: "Weekly Pass",
      //   price: 45,
      //   subtitle: "Seven Day Access",
      //   validity: "Valid For One Week",
      //   features: [
      //     "All daily yoga classes included",
      //     "Morning meditation sessions",
      //     "Evening relaxation workshops",
      //     "Access to online resources",
      //     "Personal progress tracking"
      //   ]
      // },
      {
        title: "Class Pass",
        price: 150,
        subtitle: "Ten Class Pass + 2 free classes = 12 classes",
        validity: "Valid One Year",
        features: [
          "10:00 AM – 11:00 AM Calm and Chai Sunday",
          "6:00 PM – 7:00 PM Hatha Yoga (Tuesday & Thursday)",
          "Hatha Yoga with gentle postures",
          "Breathwork to soothe the nervous system",
          "Meditation and mindfulness practice",
          "Bring a friend for free "
        ]
      }
    ];

  return (
    <>
      <div className="relative  w-full h-[70vh] flex justify-center items-center">
        {/* <video
          ref={videoRef}
          className="  absolute object-cover w-full h-full "
          autoPlay
          loop
          muted
          playsInline
        >
          <source
            src={`${process.env.PUBLIC_URL}/studiopic`}
            type="video/mp4"
          />
        </video> */}

        <img
    src={Hero}
    alt="Yoga Studio"
    className="absolute inset-0 w-full h-full object-cover object-center filter brightness-75 contrast-110"
  />




        <div className="absolute inset-0 "></div>
        <div className="text-white z-20 flex items-center justify-center flex-col md:gap-4 ">
          <div className="text-black z-20 flex items-center justify-center md:flex-row flex-col md:gap-4 ">
            {" "}
            <p className="md:text-[60px] text-[50px]     font-font2">
              Embrace The
            </p>
            <p className="md:text-[60px] text-[50px]  font-font2">Light</p>
            <p className="md:text-[60px] text-[50px]    font-font2">Within.</p>
            {/* <p className="md:hidden flex">by Jasmin.</p> */}
          </div>
          {/* <div className=" px-5 py-2 bg-[#ce6b48] rounded-lg">
            <a href="#donations" className="">
              Join Now
            </a>
          </div> */}
        </div>
      </div>

      <div className="w-full h-full items-center flex flex-col md:flex-row md:mt-0 bg-white mt-10">
        <div className="w-full items-center flex flex-col md:flex-row md:mt-0 bg-white mt-10 slide-home">
          <div className="background w-full md:w-[45%] md:h-[85dvh] text-white">
            <div className="flex justify-center background-bg p-5 flex-col bg-[#00000050] w-full h-[60dvh] md:h-[85dvh] relative">
              <h6 className="text-[14px] font-[500]"></h6>
              <h1 className="md:text-[45px] text-[35px] font-[300] leading-none my-2">
                Namaste! I’m Jasmin
              </h1>
              {/* <h6 className="text-[13px] font-[400]"> {currentDate}</h6> */}
              {/* <h6 className="text-[13px] font-[800]">By Jasmin</h6> */}
              <p className="md:text-[18px] text-[15px] font-[300] mt-10"></p>
              <Link
                to="/about"
                className="border border-[#fff] font-[800] w-[13em] h-[2.6em] text-[11px] md:text-[13px] text-center flex items-center justify-center absolute bottom-7 md:bottom-10 btn-hover"
              >
                READ MORE
              </Link>
            </div>
          </div>

          <div className="h-full  p-5 md:px-10 slides  w-full md:w-[55%] md:overflow-y-auto slide-cover flex items-center flex-col">
            <div className="w-full ">
              <h1 className="md:text-[80px] text-[60px] text-[#cccccc] font-[550]">
                Retreats
              </h1>

              <div className="w-full slides flex md:flex-row  flex-col gap-10">
                <div className="sleed ">
                  <div className="w-full md:w-[18em] sleeds mb-10 md:mb-16">
                    <div className="image-one one w-full md:w-[18em] h-[15em] relative">
                      <div className="absolute bottom-0 bg-[#c8aca5] h-3 slide-bar"></div>
                    </div>
                    <h6 className="text-[#c8aca5] mt-3 mb-1 text-[12px] font-[560]">
                      / GOA, India
                    </h6>
                    <p className="text-[30px] font-[300] mb-2 leading-none">
                      GOAN Sunset
                    </p>
                    {/* <h6 className="text-[#808080] font-[300] text-[13px]"> {currentDate}</h6> */}
                    {/* <h6 className="text-[#808080] font-[800] text-[13px]">
                      By Jasmin
                    </h6> */}
                  </div>

                  <div className="w-full md:w-[18em] sleeds mb-10 md:mb-16">
                    <div className="image-one two  w-full md:w-[18em] h-[20em] relative">
                      <div className="absolute bottom-0 bg-[#c8aca5] h-4 slide-bar"></div>
                    </div>
                    <h6 className="text-[#c8aca5] mt-3 mb-1 text-[12px] font-[560]">
                      / Dunes Holiday Village
                    </h6>
                    <p className="text-[30px] font-[300] mb-2 leading-none">
                      Deep relaxation
                    </p>
                    {/* <h6 className="text-[#808080] font-[300] text-[13px]"> {currentDate}</h6> */}
                    {/* <h6 className="text-[#808080] font-[800] text-[13px]">
                      By Jasmin
                    </h6> */}
                  </div>

                  <div className="w-full md:w-[18em] sleeds mb-10 md:mb-16">
                    <div className="image-one three  w-full md:w-[18em] h-[20em] relative">
                      <div className="absolute bottom-0 bg-[#c8aca5] h-4 slide-bar"></div>
                    </div>
                    <h6 className="text-[#c8aca5] mt-3 mb-1 text-[12px] font-[560]">
                      / Goa, India
                    </h6>
                    <p className="text-[30px] font-[300] mb-2 leading-none">
                      Warm Sandy Beach
                    </p>
                    {/* <h6 className="text-[#808080] font-[300] text-[13px]"> {currentDate}</h6> */}
                    {/* <h6 className="text-[#808080] font-[800] text-[13px]">
                      By Jasmin
                    </h6> */}
                  </div>
                </div>

                <div className="md:pt-16 hidden md:block sleed">
                  <div className="w-full md:w-[18em] sleeds mb-10 md:mb-16">
                    <div className="image-one four  w-full md:w-[18em] h-[25em] relative">
                      <div className="absolute bottom-0 bg-[#c8aca5] h-3 slide-bar"></div>
                    </div>
                    <h6 className="text-[#c8aca5] mt-3 mb-1 text-[12px] font-[560]">
                      / Dunes Holiday Village
                    </h6>
                    <p className="text-[30px] font-[300] mb-2 leading-none">Dunes Holiday Village</p>
                    {/* <h6 className="text-[#808080] font-[300] text-[13px]"> {currentDate}</h6> */}
                    {/* <h6 className="text-[#808080] font-[800] text-[13px]">
                      By Jasmin
                    </h6> */}
                  </div>

                  <div className="w-full md:w-[18em] sleeds mb-10 md:mb-16">
                    <div className="image-one five  w-full md:w-[18em] h-[25em] relative">
                      <div className="absolute bottom-0 bg-[#c8aca5] h-4 slide-bar"></div>
                    </div>
                    <h6 className="text-[#c8aca5] mt-3 mb-1 text-[12px] font-[560]">
                      / Goa,India
                    </h6>
                    <p className="text-[30px] font-[300] mb-2 leading-none">
                      Yoga Class
                    </p>
                    {/* <h6 className="text-[#808080] font-[300] text-[13px]"> {currentDate}</h6> */}
                    {/* <h6 className="text-[#808080] font-[800] text-[13px]">
                      By Jasmin
                    </h6> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Donations */}

      <div
        className="w-full flex items-center justify-center min-h-screen bg-white py-16"
        id="donations"
      >
        <div className="max-w-7xl w-full px-4">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-5xl font-light text-[#ce6b48] mb-4">
              Class Passes
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Choose the perfect pass for your yoga journey. Each option includes access to our serene sessions and mindful practices.
            </p>
          </div>
          
          {/* Cards Grid */}
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {donationCards.map((card, index) => (
              <div
                key={index}
                className="bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden border border-orange-100"
              >
                {/* Card Header */}
                <div className="relative p-8 text-center bg-[#ffffff]">
                  <div className="absolute top-0 left-0 w-full h-1 bg-[#ce6b48]"></div>
                  
                  <h3 className="text-2xl font-medium text-gray-800 mb-6">
                    {card.title}
                  </h3>
                  
                  {/* Price Display */}
                  <div className="mb-6">
                    <div className="flex items-center justify-center mb-2">
                      <span className="text-2xl font-light text-gray-500">$</span>
                      <span className="text-5xl font-bold text-[#ce6b48]">{card.price}</span>
                    </div>
                    <p className="text-gray-600 font-medium">{card.subtitle}</p>
                    <p className="text-sm text-gray-500 mt-1">{card.validity}</p>
                  </div>

                  {/* Book Now Button */}
                  <button className="w-full bg-[#ce6b48] text-white py-4 px-8 rounded-full transition-all duration-300 transform hover:scale-105 font-medium text-lg shadow-lg hover:shadow-xl">
                    Book Now
                  </button>
                </div>

                {/* Expandable Details */}
                <div className="border-t border-gray-100">
                  <button
                    onClick={() => toggleCard(index)}
                    className="w-full p-6 flex items-center justify-center gap-3 text-gray-600 hover:text-orange-600 transition-all duration-200 hover:bg-orange-50"
                  >
                    <span className="font-medium">
                      {expandedCard === index ? 'Hide Details' : 'View Details'}
                    </span>
                    <div className="transition-transform duration-300">
                      {expandedCard === index ? (
                        <ChevronUp size={20} />
                      ) : (
                        <ChevronDown size={20} />
                      )}
                    </div>
                  </button>
                  
                  <div
                    className={`overflow-hidden transition-all duration-500 ease-in-out ${
                      expandedCard === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                    }`}
                  >
                    <div className="px-6 pb-6 space-y-4">
                      {card.features.map((feature, featureIndex) => (
                        <div
                          key={featureIndex}
                          className="flex items-start gap-3 text-gray-700"
                        >
                          <Check size={18} className="text-orange-500 mt-0.5 flex-shrink-0" />
                          <span className="leading-relaxed">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className="text-center mt-16">
            <p className="text-gray-600 mb-6">
              Need help choosing the right pass? We're here to guide you.
            </p>
            <button className="px-8 py-3 border-2 border-[#ce6b48] text-[#ce6b48] hover:bg-[#ce6b48] hover:text-white rounded-full transition-all duration-300 font-medium">
              Contact Us
            </button>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade-in {
          animation: fade-in 1s ease-out;
        }
      `}</style>
    </>
  );
};

export default Home;
